import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavLink } from 'core/types/nav-link';

@Component({
  selector: 'app-account',
  template: `
    <app-main-layout [navLinks]="navLinks">
    </app-main-layout>`,
  styleUrls: ['./account.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccountComponent {
  navLinks: NavLink[] = [
    {
      path: 'profile-info',
      icon: 'account_box',
      linkActiveOptions: { exact: true },
      label: 'SIDENAV.ACCOUNT.profile',
    },
  ];

  constructor() {
  }
}
